const isNumber = (number?: unknown): boolean => {
    return Number.isFinite(number);
}

export default isNumber;
